import React from 'react';

import { DOMNode, Element } from 'html-react-parser';

import { findText } from './link';

const paragraphParser = (domNode: DOMNode) => {
  if (domNode instanceof Element && domNode.attribs) {
    if (domNode.type === 'tag' && domNode.name === 'p' && domNode.children?.length) {
      const text = findText(domNode.children);

      return <span>{text}</span>;
    }

    return <></>;
  }

  return <></>;
};

export default paragraphParser;
